module.exports = __webpack_public_path__ + "img/Miranda_Klein.06eec779.png";